<template>
  <div class="drawflow-detail">
    <div class="header">
      <div>
        <v-icon> {{ data.ui.icon }} </v-icon>
        <span class="ml-3">{{ data.ui.title }}</span>
      </div>
      <div class="d-flex align-center">
        <v-btn small color="primary" outlined class="m-l-15" @click="close"
          >Cancel</v-btn
        >
        <v-btn small color="primary" dark class="m-l-10" @click="save"
          >OK</v-btn
        >
      </div>
    </div>
    <div class="body">
      <!-- common -->
      <dialog-add-retry
        v-if="data.node === 'add_retry'"
        :node="data"
        :items="items"
        :tabs="tabs"
        @goToPage="goToPage"
      />
      <dialog-api
        v-else-if="data.node === 'api'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-checkpoint
        v-else-if="data.node === 'checkpoint'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <!--use for Intellisense dialog-checkpoint มีเพิ่ม :drawFlowItems="drawFlowItems" เพื่อใช้ใน Intellisense -->
      <dialog-clear-retry
        v-else-if="data.node === 'clear_retry'"
        :node="data"
      />
      <dialog-code
        v-else-if="data.node === 'code'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-condition
        v-else-if="data.node === 'condition'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-enter v-else-if="data.node === 'enter'" :node="data" />
      <dialog-exit v-else-if="data.node === 'exit'" :node="data" />
      <dialog-intent-mapping
        v-else-if="data.node === 'intent_mapping'"
        :node="data"
        :tabs="tabs"
        :drawFlowItems="drawFlowItems"
        @goToPage="goToPage"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-jump
        v-else-if="data.node === 'jump'"
        :node="data"
        :items="items"
        :tabs="tabs"
        :currentTab="currentTab"
      />
      <dialog-loop
        v-else-if="data.node === 'loop'"
        :node="data"
        :tabs="tabs"
        :currentTab="currentTab"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
        @goToPage="goToPage"
      />
      <dialog-mail
        v-else-if="data.node === 'mail'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-note v-else-if="data.node === 'note'" :node="data" />
      <dialog-page
        v-else-if="data.node === 'page'"
        :node="data"
        :tabs="tabs"
        :currentTab="currentTab"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
        @goToPage="goToPage"
      />
      <dialog-random
        v-else-if="data.node === 'random'"
        :node="data"
        :drawFlowItems="drawFlowItems"
      />
      <dialog-schedule v-else-if="data.node === 'schedule'" :node="data" />
      <dialog-stamp-service
        v-else-if="data.node === 'stamp_service'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-write
        v-else-if="data.node === 'write'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-log
        v-else-if="data.node === 'log'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-gen-AI
        v-else-if="data.node === 'gen_ai'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <!-- common -->
      <!-- voice -->
      <dialog-voice-disconnect
        v-else-if="data.node === 'disconnect'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <!--use for Intellisense dialog-voice-disconnect มีเพิ่ม :drawFlowItems="drawFlowItems" เพื่อใช้ใน Intellisense -->
      <dialog-voice-input
        v-else-if="data.node === 'input'"
        :node="data"
        :start="drawFlowItems.Home.data['1']"
      />
      <dialog-voice-prompt
        v-else-if="data.node === 'prompt'"
        :node="data"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <dialog-voice-return-vxml
        v-else-if="data.node === 'return_vxml'"
        :node="data"
      />
      <dialog-voice-start
        v-else-if="data.node === 'start'"
        :node="data"
        :tabs="tabs"
        :ttsChoices="ttsChoices"
      />
      <dialog-voice-transfer
        v-else-if="data.node === 'transfer'"
        :node="data"
        :flowId="flowId"
        :drawFlowItems="drawFlowItems"
        :apiForIntellisense="apiForIntellisense"
      />
      <!-- voice -->
      <!-- chat -->
      <dialog-chat-disconnect
        v-else-if="data.node === 'chat_disconnect'"
        :node="data"
      />
      <dialog-chat-input v-else-if="data.node === 'chat_input'" :node="data" />
      <dialog-chat-output
        v-else-if="data.node === 'chat_output'"
        :node="data"
        :drawFlowItems="drawFlowItems"
      />
      <dialog-chat-start
        v-if="data.node === 'chat_start'"
        :node="data"
        :tabs="tabs"
        :ttsChoices="ttsChoices"
      />
      <dialog-chat-transfer
        v-else-if="data.node === 'chat_transfer'"
        :node="data"
        :flowId="flowId"
      />
      <!-- chat -->
    </div>

    <div class="body-error red--text text-center">{{ errorMessage }}</div>

    <!-- <div class="footer">
      <v-btn small class="btn-secondary" text @click="close">Cancel</v-btn>
      <v-btn small class="btn-primary m-l-10" text @click="save">OK</v-btn>
    </div> -->

    <v-overlay :absolute="true" :value="overlay">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="80"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import _ from 'lodash'
import bus from './../utils/event-bus'

import apiGrammar from '@/apis/grammar'
import apiFlow from '@/apis/flow'

// dialog common
import DialogAddRetry from './common/add_retry/dialog'
import DialogApi from './common/api/dialog'
import DialogCheckpoint from './common/checkpoint/dialog'
import DialogClearRetry from './common/clear_retry/dialog'
import DialogCode from './common/code/dialog'
import DialogCondition from './common/condition/dialog'
import DialogEnter from './common/enter/dialog'
import DialogExit from './common/exit/dialog'
import DialogGenAI from './common/gen_ai/dialog'
import DialogIntentMapping from './common/intent_mapping/dialog'
import DialogJump from './common/jump/dialog'
import DialogLog from './common/log/dialog'
import DialogLoop from './common/loop/dialog'
import DialogMail from './common/mail/dialog'
import DialogNote from './common/note/dialog'
import DialogPage from './common/page/dialog'
import DialogRandom from './common/random/dialog'
import DialogSchedule from './common/schedule/dialog.vue'
import DialogStampService from './common/stamp_service/dialog'
import DialogWrite from './common/write/dialog'

// dialog voice
import DialogVoiceDisconnect from './voice/disconnect/dialog'
import DialogVoiceInput from './voice/input/dialog'
import DialogVoicePrompt from './voice/prompt/dialog'
import DialogVoiceReturnVxml from './voice/return_vxml/dialog'
import DialogVoiceStart from './voice/start/dialog'
import DialogVoiceTransfer from './voice/transfer/dialog'

// dialog chat
import DialogChatDisconnect from './chat/disconnect/dialog'
import DialogChatInput from './chat/input/dialog'
import DialogChatOutput from './chat/output/dialog'
import DialogChatStart from './chat/start/dialog'
import DialogChatTransfer from './chat/transfer/dialog'

import Transform from '../utils/transform'

export default {
  props: {
    node: Object,
    tabs: Array,
    items: Array,
    isNameDuplicated: String,
    currentTab: String,
    drawFlowItems: Object,
    ttsChoices: Array,
    flowId: String,
    errorFromValidate: String,
    // ใช้สำหรับ intellisense code
    apiForIntellisense: Object
    // ใช้สำหรับ intellisense code
  },
  components: {
    // dialog common
    DialogAddRetry,
    DialogApi,
    DialogCheckpoint,
    DialogClearRetry,
    DialogCode,
    DialogCondition,
    DialogEnter,
    DialogExit,
    DialogGenAI,
    DialogIntentMapping,
    DialogJump,
    DialogLoop,
    DialogMail,
    DialogNote,
    DialogPage,
    DialogRandom,
    DialogSchedule,
    DialogStampService,
    DialogWrite,
    DialogLog,

    // dialog voice
    DialogVoiceDisconnect,
    DialogVoiceInput,
    DialogVoicePrompt,
    DialogVoiceReturnVxml,
    DialogVoiceStart,
    DialogVoiceTransfer,

    // dialog chat
    DialogChatDisconnect,
    DialogChatInput,
    DialogChatOutput,
    DialogChatStart,
    DialogChatTransfer
  },
  data() {
    return {
      data: {},
      property: {},
      errorMessage: '',
      overlay: false
    }
  },
  watch: {
    isNameDuplicated: {
      handler(value) {
        if (value) {
          this.errorMessage = `${value} already exists`
        }
      }
    }
  },
  created() {
    this.data = JSON.parse(JSON.stringify(this.node.data))

    if (this.errorFromValidate) {
      this.errorMessage = this.errorFromValidate
    }

    // esc pressed
    document.onkeydown = evt => {
      evt = evt || window.event
      if (evt.keyCode == 27) {
        this.close()
      }
    }
  },
  methods: {
    replaceParametes({ rawText, replaceValue }) {
      let startIndex = -1
      let endIndex = 0
      try {
        do {
          startIndex = rawText.indexOf('${', endIndex)
          if (startIndex >= 0) {
            endIndex = rawText.indexOf('}', startIndex)
            if (endIndex > startIndex) {
              const parameter = rawText.substring(startIndex, endIndex + 1)
              rawText = rawText.replace(parameter, replaceValue)
            } else {
              break
            }
          }
        } while (startIndex >= 0)
      } catch {}

      return rawText
    },
    close() {
      // this.node.data = this.data
      this.node.data.name = this.node.name
      this.data.name = this.node.name

      bus.$emit('closeDrawflowDetail', null)
      // this.save()
    },
    async save() {
      const transform = new Transform({}, this.tabs)
      const errorData = transform.validateData(this.data)
      if (errorData) {
        this.errorMessage = errorData
        return
      }

      let mailAttachments = []
      if (this.data.node === 'mail') {
        mailAttachments = this.data.property.tempAttachments
      }

      this.data = transform.assignData(this.data)

      // CHAT-2512 : อัพเดตการแสดงผล Max retries
      if (this.data.node === 'start') {
        this.data.property.flow.fallback_after -= 1
      }

      // mail only
      if (this.data.node === 'mail') {
        if (mailAttachments && mailAttachments.length > 0) {
          if (!this.data.property.attachments)
            this.data.property.attachments = []

          this.overlay = true
          const temp = _.cloneDeep(mailAttachments)

          for (const attach of temp) {
            const formData = new FormData()
            formData.append('file', attach)
            try {
              const response = await apiFlow.uploadFlowMailAttachment(formData)

              if (response.data) {
                this.data.property.attachments.push(response.data)
                this.data.property.tempAttachments.splice(0, 1)
                mailAttachments.splice(0, 1)
              } else {
                this.overlay = false
                this.errorMessage = response.message
                return
              }
            } catch {
              this.overlay = false
              this.errorMessage = 'Upload error'
              return
            }
          }

          this.overlay = false
        }
        delete this.data.property.tempAttachments
      }

      bus.$emit('confirmDrawflowDetail', { node: this.node, data: this.data })
    },
    goToPage(pageId) {
      this.close()
      this.$emit('goToPage', pageId)
    }
  }
}
</script>
